import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isMobileSelector, isSdkSelector } from 'redux/selectors/global';

export const useViewRenderer = () => {
  const isMobile = useSelector(isMobileSelector);
  const isSdk = useSelector(isSdkSelector);
  const isMobileNotSdk = isMobile && !isSdk;

  const renderFunc = useCallback(
    (components, props, ref) => {
      let CompToRender;
      const { mobile, sdk, desktop } = components;
      if (isMobileNotSdk) {
        CompToRender = mobile;
      } else if (isSdk) {
        CompToRender = sdk;
      } else {
        CompToRender = desktop;
      }

      return <CompToRender {...props} ref={ref} />;
    },
    [isMobile, isSdk]
  );

  return renderFunc;
};
